/*! Collage banner: light scroll effect for the sticker images. Vanilla JS, transform only. */
(function () {
  'use strict';
  if (customElements.get('collage-banner')) return;

  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  class CollageBanner extends HTMLElement {
    connectedCallback() {
      this.stickers = Array.prototype.slice.call(this.querySelectorAll('.collage__sticker'));
      if (!this.stickers.length || reducedMotion) return;

      this.wobbleEnabled = this.getAttribute('data-wobble') === 'true';
      this.wobbleDuration = (parseInt(this.getAttribute('data-wobble-duration'), 10) || 3) * 1000;
      this.wobbleCooldown = (parseInt(this.getAttribute('data-wobble-cooldown'), 10) || 0) * 1000;
      this.lastWobble = -Infinity;
      this.inView = false;
      this.ticking = false;

      this.stickers.forEach(function (sticker) {
        sticker.style.setProperty('--wobble-duration', (this.wobbleDuration / 1000) + 's');
      }, this);

      this.onScroll = this.onScroll.bind(this);
      this.observer = new IntersectionObserver(this.onIntersect.bind(this), { threshold: 0 });
      this.observer.observe(this);
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
      window.removeEventListener('scroll', this.onScroll);
    }

    onIntersect(entries) {
      var visible = entries[0].isIntersecting;
      if (visible && !this.inView) {
        window.addEventListener('scroll', this.onScroll, { passive: true });
      } else if (!visible && this.inView) {
        window.removeEventListener('scroll', this.onScroll);
      }
      this.inView = visible;
    }

    onScroll() {
      if (this.ticking) return;
      this.ticking = true;
      requestAnimationFrame(this.update.bind(this));
    }

    update() {
      this.ticking = false;
      // Slight "sticky" drift: stickers follow the scroll at 12% of its speed.
      var rect = this.getBoundingClientRect();
      var offset = Math.max(-rect.height, Math.min(rect.height, -rect.top)) * 0.12;
      this.stickers.forEach(function (sticker) {
        sticker.style.setProperty('--sticker-scroll', offset.toFixed(1) + 'px');
      });

      if (!this.wobbleEnabled) return;
      var now = performance.now();
      if (now - this.lastWobble < this.wobbleDuration + this.wobbleCooldown) return;
      this.lastWobble = now;
      this.wobble();
    }

    wobble() {
      var self = this;
      this.stickers.forEach(function (sticker) {
        sticker.classList.remove('is-wobbling');
        void sticker.offsetWidth;
        sticker.classList.add('is-wobbling');
      });
      clearTimeout(this.wobbleTimer);
      this.wobbleTimer = setTimeout(function () {
        self.stickers.forEach(function (sticker) { sticker.classList.remove('is-wobbling'); });
      }, this.wobbleDuration + 50);
    }
  }

  customElements.define('collage-banner', CollageBanner);
})();
